<template>
  <div>
    <v-toolbar class="transparent elevation-0 my-3">
      <div class="headline">Locations</div>
      <v-spacer />
      <can I="edit" a="Opportunity">
        <v-btn round @click="add" color="secondary">
          <v-icon>mdi-plus</v-icon> Add Location
        </v-btn>
      </can>
    </v-toolbar>

    <v-card dark>
      <v-list>
        <v-list-tile avatar @click=";"
          v-for="(location, i) in opportunity.locations" :key="`location-${i}`"
        >
          <v-list-tile-avatar>
            <v-avatar v-if="location.countryCode" size="22px">
              <img :class="`flag-icon-background flag-icon-squared flag-icon-${location.countryCode.toLowerCase()}`" style="padding: 16px" />
            </v-avatar>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title><strong>{{ location.address }}</strong></v-list-tile-title>
            <v-list-tile-sub-title class="subheading grey--text">
              <span v-if="location.intake > 0">
                {{ location.intake }} position(s) available
              </span>
              <span v-else>disabled</span>
            </v-list-tile-sub-title>
          </v-list-tile-content>

          <v-list-tile-action>
            <can I="edit" a="Opportunity">
              <v-dialog v-model="location.editing">
                <v-btn icon small flat fab slot="activator">
                  <v-icon>mdi-pencil</v-icon>
                </v-btn>

                <v-card>
                  <v-card-title class="title">Update {{ location.address }}</v-card-title>
                  <v-card-text>
                    <v-slider thumb-label
                      label="Intake" v-model="location.intake"
                      :messages="location.intake === 0 ? ['Setting the intake to zero removes the location from the application options'] : []"
                    />
                  </v-card-text>
                  <v-card-actions><v-spacer />
                    <v-btn flat @click="location.editing = false" color="grey">
                      Cancel
                    </v-btn>
                    <v-btn color="primary" @click="update(location)">Update</v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </can>
          </v-list-tile-action>

          <v-list-tile-action>
            <can I="edit" a="Opportunity">
              <v-menu left>
                <v-btn icon small flat fab slot="activator" color="error">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
                <v-card>
                  <v-card-title>Remove {{ location.address }}?</v-card-title>
                  <v-card-actions>
                    <v-btn @click="remove(location.id)" block color="error">
                      Remove
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-menu>
            </can>
          </v-list-tile-action>
        </v-list-tile>
      </v-list>

      <v-card-text v-if="adding">
        <v-text-field
          label="Address"
          v-model="address"
          required
        />

        <v-btn small
          v-for="location in missingLocations" :key="`add-location-${location.id}`"
          @click="attach(location.id)"
          color="secondary"
        >
          Add {{ location.address }}
        </v-btn>
      </v-card-text>
      <v-card-actions v-if="adding"><v-spacer />
        <v-btn flat @click="cancel" color="grey">Cancel</v-btn>
        <v-btn @click="create" color="primary">Add</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
// Vue Component
export default {
  data() {
    return {
      adding: false,
      address: ''
    }
  },
  computed: {
    opportunity() {
      return this.$store.getters['admin/opportunities/find']()
    },
    missingLocations() {
      return this.opportunity.organization.locations.filter(orgLoc =>
        this.opportunity.locations.every(opLoc => opLoc.location.id != orgLoc.id)
      )
    },
  },
  methods: {
    add() {
      this.adding = true
    },
    cancel() {
      this.adding = false
      this.address = ''
    },
    create() {
      this.$store
        .dispatch('admin/opportunities/createLocation', {
          opportunity: { id: this.opportunity.id },
          address: this.address,
        })
        .then(this.cancel)
    },
    attach(locationId) {
      this.$store
        .dispatch('admin/opportunities/createLocation', {
          opportunity: { id: this.opportunity.id },
          id: locationId,
        })
        .then(this.cancel)
    },
    remove(id) {
      this.$store.dispatch('admin/opportunities/removeLocation', {
        opportunity: { id: this.opportunity.id },
        id: id,
      })
    },
    update(location) {
      this.$store.dispatch('admin/opportunities/updateLocation', {
        opportunity: { id: this.opportunity.id },
        id: location.id,
        intake: location.intake,
      })
    }
  },
}
</script>
